import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatIconModule } from '@angular/material/icon';
import {
    PaymentIntegrationFormFieldModule,
} from 'apps/public-portal/src/app/payment-integrations/base/components/payment-integration-form-field/payment-integration-form-field.component';
import { TellerOnlineIconsModule } from 'teller-online-libraries/icons';
import { VgsCollectCreditComponent } from './vgs-collect-credit.component';
import { VgsCollectCvvOnlyComponent } from './vgs-collect-cvv-only.component';
import { VgsCollectEcheckComponent } from './vgs-collect-echeck.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatLegacyFormFieldModule,
        MatLegacyInputModule,
        MatLegacyCheckboxModule,
        MatLegacySelectModule,
        MatIconModule,
        PaymentIntegrationFormFieldModule,
        TellerOnlineIconsModule,
    ],
    declarations: [VgsCollectCreditComponent, VgsCollectCvvOnlyComponent, VgsCollectEcheckComponent],
    exports: [VgsCollectCreditComponent, VgsCollectCvvOnlyComponent, VgsCollectEcheckComponent],
})
export class VgsCollectModule { }
